import { Box, Text } from '@chakra-ui/react';
import { useLocation } from 'react-router';

import { RouterLink } from '@/components/atoms/RouterLink';
import { EvolveLogo } from '@/components/brand';
import { applicationsRoute } from '@/constants';

import { NavItem } from './NavItem';
import { isNavItemActive, useNavGroups } from './Sidebar.hooks';
import { navGroupCss, sidebarCss } from './Sidebar.styles';

type SidebarProps = {
  variant?: 'aside' | 'drawer';
  onNavigate?: () => void;
};

export const Sidebar = ({ variant = 'aside', onNavigate }: SidebarProps) => {
  const { pathname } = useLocation();
  const groups = useNavGroups();

  return (
    <Box
      as={variant === 'aside' ? 'aside' : 'div'}
      className="Sidebar"
      data-variant={variant}
      css={sidebarCss}
    >
      <RouterLink
        to={applicationsRoute}
        className="logo-link"
        aria-label="evolve AI home"
        onClick={onNavigate}
      >
        <EvolveLogo aria-hidden="true" />
      </RouterLink>

      <Box as="nav" className="nav-groups" aria-label="Main navigation">
        {groups.map((group) => (
          <Box
            as="ul"
            key={group.label}
            css={navGroupCss}
            aria-label={group.label}
          >
            <Text as="li" className="nav-group-label" aria-hidden="true">
              {group.label}
            </Text>
            {group.items.map((item) => (
              <li key={item.label}>
                <NavItem
                  item={item}
                  active={isNavItemActive(item.to, pathname)}
                  onNavigate={onNavigate}
                />
              </li>
            ))}
          </Box>
        ))}
      </Box>

      <Text className="version">
        {`v${import.meta.env.VITE_PACKAGE_VERSION} #${import.meta.env.VITE_COMMIT_HASH}`}
      </Text>
    </Box>
  );
};
